import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { StepsContext } from './steps-context';

export class Step extends React.PureComponent {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
      PropTypes.number,
      PropTypes.func,
    ]),
    // This is required for its parent step-group-view
    /* eslint-disable react/no-unused-prop-types */
    path: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
    ]).isRequired,
    /* eslint-enable react/no-unused-prop-types */
  };

  static defaultProps = {
    title: null,
  };

  renderTitle = (context) => {
    if (!_.isBoolean(context.isActive) || !_.isBoolean(context.isPrevious)) {
      throw new Error('Steps Context not found. <Step /> should only be rendered within <StepContainer />');
    }
    const { title } = this.props;
    if (_.isFunction(title)) {
      return title({
        isActive: context.isActive,
        isPrevious: context.isPrevious,
      });
    }
    return title;
  }

  render() {
    return (
      <StepsContext.Consumer>
        {this.renderTitle}
      </StepsContext.Consumer>
    );
  }
}
